import {
  Badge,
  Button,
  Center,
  Container,
  GridItem,
  Heading,
  HStack,
  Icon,
  Image,
  LinkBox,
  LinkOverlay,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import css from './ProviderTypesSection.module.css';
import { capitalize } from 'lodash';

const providerSections = [
  {
    sectionId: 'gym',
    sectionBackgroundClassname: '',
    header: 'Gyms',
    subheader: 'Explore top gyms — or get your gym discovered',
    text: (
      <span>
        Whether you're looking for a place to train or looking to grow your membership,
        <span className={css.footfallLogo}> FootFall </span>connects both sides of fitness.
      </span>
    ),
    imgSrc:
      'https://res.cloudinary.com/dtknri7vc/image/upload/v1765561297/Southwark-Castle-Leisure-Centre-gym-floor_cmmlqq.png',
    searchUrl: '/s?pub_categoryLevel1=gym',
    businessUrl: '/signup/fitness-venue',
    textFirst: false,
  },
  {
    sectionId: 'sports-club',
    sectionBackgroundClassname: css.sectionBackground,
    header: 'Sports Clubs',
    subheader: 'Players. Teams. One place.',
    text: (
      <span>
        Players find clubs. Clubs find players.<span className={css.footfallLogo}> FootFall </span>
        brings sports communities together.
      </span>
    ),
    imgSrc: 'https://res.cloudinary.com/dtknri7vc/image/upload/v1765561453/Rugby_3_ptyyjs.jpg',
    searchUrl: '/s?pub_categoryLevel1=sports-club',
    businessUrl: '/signup/sports-club',
    textFirst: true,
  },
  {
    sectionId: 'class',
    sectionBackgroundClassname: '',
    header: 'Fitness Classes',
    subheader: 'Where classes get seen (and booked)',
    text: (
      <span>
        From pilates to circuit training,<span className={css.footfallLogo}> FootFall </span>
        connects people who love to move with the classes that move them.
      </span>
    ),
    imgSrc: 'https://res.cloudinary.com/dtknri7vc/image/upload/v1765561297/class_photo_l3hamf.png',
    searchUrl: '/s?pub_categoryLevel1=class',
    businessUrl: '/signup/independent-provider',
    textFirst: false,
  },
  {
    sectionId: 'personal-trainer',
    sectionBackgroundClassname: css.sectionBackground,
    header: 'Personal Trainers',
    subheader: 'Your next session starts here',
    text: <span>Find a trainer who gets results — or be the trainer everyone finds.</span>,
    imgSrc: 'https://res.cloudinary.com/dtknri7vc/image/upload/v1765561293/pt_photo_kqazbw.jpg',
    searchUrl: '/s?pub_categoryLevel1=personal-trainer',
    businessUrl: '/signup/freelance-personal-trainer',
    textFirst: true,
  },
];

const PhotoTextSection = ({
  sectionId,
  sectionBackgroundClassname,
  header,
  subheader,
  text,
  imgSrc,
  searchUrl,
  businessUrl,
  textFirst,
}) => {
  const PhotoSection = () => (
    <GridItem className={css.image} borderRadius="lg">
      <Image src={imgSrc} alt={header} aspectRatio={1} borderRadius="lg" />
    </GridItem>
  );

  const TextSection = () => (
    <GridItem>
      <Heading
        size={{
          base: '3xl',
          lg: '5xl',
        }}
        fontWeight={'bold'}
        mb={0}
      >
        {subheader}
      </Heading>
      <Text
        fontSize={{
          base: 'md',
          lg: 'lg',
        }}
        fontWeight="medium"
        color={'lightGreyText'}
        mt={0}
        mb={'1rem'}
      >
        {text}
      </Text>
      <HStack mt={'2rem'} gap={'1rem'}>
        <LinkBox>
          <LinkOverlay href={searchUrl}>
            <Button variant="solid" colorPalette={'purple'}>
              <Icon>
                <SearchRoundedIcon />
              </Icon>
              {capitalize(header)}
            </Button>
          </LinkOverlay>
        </LinkBox>
        <LinkBox>
          <LinkOverlay href={businessUrl}>
            <Button variant="outline" colorPalette={'purple'}>
              Learn more
            </Button>
          </LinkOverlay>
        </LinkBox>
      </HStack>
    </GridItem>
  );

  return (
    <section id={sectionId} className={sectionBackgroundClassname}>
      <Container maxW={'5xl'} p={'5rem 2rem'}>
        <Center>
          <Badge size="md" colorPalette="purple" variant="surface" mb={'2rem'}>
            {header}
          </Badge>
        </Center>
        <SimpleGrid columns={{ base: 2, mdDown: 1 }} gap={'5rem'}>
          {textFirst ? <TextSection /> : <PhotoSection />}
          {!textFirst ? <TextSection /> : <PhotoSection />}
        </SimpleGrid>
      </Container>
    </section>
  );
};

const ProviderTypesSection = () => {
  return (
    <section id={'provider-types'}>
      {providerSections.map(providerSection => (
        <PhotoTextSection
          key={providerSection.sectionId}
          sectionId={providerSection.sectionId}
          sectionBackgroundClassname={providerSection.sectionBackgroundClassname}
          header={providerSection.header}
          subheader={providerSection.subheader}
          text={providerSection.text}
          imgSrc={providerSection.imgSrc}
          searchUrl={providerSection.searchUrl}
          businessUrl={providerSection.businessUrl}
          textFirst={providerSection.textFirst}
        />
      ))}
    </section>
  );
};

export default ProviderTypesSection;
